import React from "react";
import clsx from "clsx";
import { SparkleIcon } from "./SparkleIcon";
import { ReactNode } from "react";

type QuoteCardTheme = "normal" | "highlighted";

export const QuoteCard: React.FC<{
  cardTheme?: QuoteCardTheme;
  borderTheme?: QuoteCardTheme;
  tag?: ReactNode;
  tagTheme?: QuoteCardTheme;
  includeSparkle?: boolean;
}> = ({
  cardTheme = "normal",
  borderTheme = "normal",
  tag,
  tagTheme = "normal",
  includeSparkle = false,
  children,
}) => {
  return (
    <div className="relative w-full max-w-[600px]">
      {tag && (
        <div className="absolute -top-4 left-0 flex h-8 w-full justify-center sm:-top-5 sm:h-10">
          <span
            className={clsx(
              "flex h-full items-center rounded-full px-4 font-bold sm:px-6 sm:text-lg",
              tagTheme === "normal"
                ? "border border-gray-300 bg-white"
                : "bg-dm-brand-blue-500 text-white"
            )}
          >
            {tag}
          </span>
        </div>
      )}

      {includeSparkle && (
        <span className="absolute -right-[14px] -top-[14px] h-[44px] w-[44px] sm:-right-[18px] sm:-top-[18px] sm:h-[60px] sm:w-[60px]">
          <SparkleIcon />
        </span>
      )}

      <div
        className={clsx(
          "flex flex-col gap-8 rounded-xl px-4 font-sans shadow-[0_26px_40px_0px_rgba(1,39,88,0.04)] sm:px-10",
          cardTheme === "normal" ? "bg-white" : "bg-dm-brand-blue-100",
          borderTheme === "normal"
            ? "border border-gray-300"
            : "border-2 border-dm-brand-blue-500",
          tag ? "py-8 sm:py-10" : "py-4 sm:py-10"
        )}
      >
        {children}
      </div>
    </div>
  );
};
